function isDefined(object) {
    return !(typeof object === "undefined");
}
/**
 * Calculation of the k-Factors to calibrate the axis-Length, due to a nominalLength
 */
export function calculate_k_factor(axis, nominallengthattribute, offsetattribute) {
    const k = [];
    for (let i = 0; i < axis["features"].length; i++) {
        const k_offset = [];
        if (isDefined(nominallengthattribute) && isDefined(axis["features"][i]["properties"][nominallengthattribute])) {
            let actualDistance = 0;
            const nominalDistance = axis["features"][i]["properties"][nominallengthattribute];
            const coords = axis["features"][i]["geometry"]["coordinates"];
            for (let j = 0; j < coords.length - 1; j++) {
                //2D-Distance
                const dist = Math.sqrt(Math.pow(coords[j + 1][0] - coords[j][0], 2) + Math.pow(coords[j + 1][1] - coords[j][1], 2));
                actualDistance = actualDistance + dist;
            }
            k_offset.push(actualDistance / nominalDistance);
        }
        else {
            k_offset.push(1);
        }
        if (isDefined(offsetattribute) && isDefined(axis["features"][i]["properties"][offsetattribute])) {
            const offset = axis["features"][i]["properties"][offsetattribute];
            k_offset.push(offset);
        }
        else {
            k_offset.push(0);
        }
        k.push(k_offset);
    }
    return k;
}
//# sourceMappingURL=utils.js.map